import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useDropzone } from 'react-dropzone';

// Import styles
import { Wrapper, Zone, Title, SubTitle, FileList } from './styles';
import FileTag from './components/FileTag';

// Import helpers
import { getCustomValidator } from './helpers';
import useAttachments from './useAttachments';

function DragAndDropUploader({ allowedMimes, maxTotalSize, maxSizePerFile, maxFileCount, allowMultiple, subtitle, disabled, onChange, clear }) {
	const { t } = useTranslation();
	const { files, onDropAccepted, onDropRejected, removeFile } = useAttachments({
		clear,
		maxTotalSize,
		maxFileCount
	});

	const validator = getCustomValidator({
		maxSizePerFile,
		maxTotalSize,
		allowedMimes
	});

	useEffect(() => {
		onChange(files);
		//eslint-disable-next-line
	}, [files]);

	const { fileRejections, getRootProps, getInputProps, isFocused, isDragAccept, isDragReject, isFileDialogActive } = useDropzone({
		disabled,
		accept: allowedMimes,
		validator,
		onDropAccepted,
		onDropRejected,
		multiple: allowMultiple
	});

	return (
		<Wrapper>
			<Zone
				{...getRootProps({
					isFocused,
					isDragAccept,
					isDragReject,
					isFileDialogActive,
					someError: fileRejections.length
				})}
			>
				<input {...getInputProps()} />
				<Title>
					{t('contact_form_uploader_title')} <span>{t('contact_form_uploader_subtitle')}</span>
				</Title>
				<SubTitle>{subtitle}</SubTitle>
			</Zone>
			<FileList>
				{files.map(({ name, size }) => (
					<FileTag key={name} name={name} size={size} remove={removeFile} />
				))}
			</FileList>
		</Wrapper>
	);
}

DragAndDropUploader.defaultProps = {
	disabled: false,
	allowedMimes: [],
	allowMultiple: false,
	maxSizePerFile: 0
};

DragAndDropUploader.propTypes = {
	allowedMimes: PropTypes.array,
	maxTotalSize: PropTypes.number,
	maxSizePerFile: PropTypes.number,
	maxFileCount: PropTypes.number,
	allowMultiple: PropTypes.bool,
	subtitle: PropTypes.element,
	disabled: PropTypes.bool,
	onChange: PropTypes.func,
	clear: PropTypes.bool
};

export default DragAndDropUploader;
